import { render, staticRenderFns } from "./EventsContestantsFilterClubs.vue?vue&type=template&id=14bfea3c&"
import script from "./EventsContestantsFilterClubs.vue?vue&type=script&lang=ts&"
export * from "./EventsContestantsFilterClubs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports